// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Label */
    --ds-input-disabled-label-color: var(--ds-color-grey-indigo-30);
    --ds-input-readonly-label-color: var(--ds-input-disabled-label-color);
    /* Tooltip */
    --ds-input-label-tooltip-icon-color: var(--ds-color-grey-20);
    /* Description */
    --ds-input-disabled-description-color: var(--ds-color-grey-indigo-30);
    --ds-input-readonly-description-color: var(
        --ds-input-disabled-description-color
    );
    /* Placeholder */
    --ds-input-field-placeholder-color: var(--ds-color-grey-20);
    --ds-input-field-disabled-placeholder-color: var(--ds-color-grey-30);
    /* Field */
    --ds-input-field-text-color: var(--ds-color-grey-10);
    --ds-input-field-disabled-text-color: var(--ds-color-grey-30);
    --ds-input-field-readonly-text-color: var(--ds-color-grey-indigo-30);
    --ds-input-field-bg-color: var(--ds-color-grey-indigo-80);
    --ds-input-field-disabled-bg-color: var(--ds-color-grey-indigo-90);
    /* Input icon */
    --ds-input-field-icon-color: var(--ds-color-grey-20);
    --ds-input-field-focused-icon-color: var(--ds-color-grey-10);
    --ds-input-field-disabled-icon-color: var(--ds-color-grey-30);
    /* Field borders */
    --ds-input-field-border-color: var(--ds-color-grey-indigo-40);
    --ds-input-field-focused-border-color: var(--ds-color-neon-0);
    --ds-input-field-error-border-color: var(--ds-color-negative);
    --ds-input-field-disabled-border-color: var(--ds-color-grey-indigo-60);
    --ds-input-field-readonly-border-color: var(
        --ds-input-field-disabled-border-color
    );
    --ds-input-field-hover-border-color: var(--ds-color-grey-20);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
